"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVGIcon = require("../../SVGIcon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var HelpIcon = function HelpIcon(props) {
  return _react["default"].createElement(_SVGIcon.SvgIcon, _extends({
    viewBox: "0 0 18 18"
  }, props), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M-1-1h20v20H-1z"
  }), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8.16667 14h1.66666v-1.66667H8.16667V14zM9 .66667C4.4.66667.66667 4.4.66667 9S4.4 17.33333 9 17.33333 17.33333 13.6 17.33333 9 13.6.66667 9 .66667zm0 15C5.325 15.66667 2.33333 12.675 2.33333 9S5.325 2.33333 9 2.33333 15.66667 5.325 15.66667 9 12.675 15.66667 9 15.66667zM9 4C7.15833 4 5.66667 5.49167 5.66667 7.33333h1.66666c0-.91666.75-1.66666 1.66667-1.66666.91667 0 1.66667.75 1.66667 1.66666 0 1.66667-2.5 1.45834-2.5 4.16667h1.66666c0-1.875 2.5-2.08333 2.5-4.16667C12.33333 5.49167 10.84167 4 9 4z"
  })));
};

exports.HelpIcon = HelpIcon;